import styled from 'styled-components';
import Modal from '@iso/components/Feedback/Modal';
import WithDirection from '@iso/lib/helpers/rtl';

const PreviewTemplateWrapper = styled(Modal)`
  .preview-form-area {
    border: solid 1px gray;
  }
  .btn-success{
      background-color: #0B2A1B!important;
      border-color: #0B2A1B!important;
  }
  .ant-modal-body{
    padding: 0px !important
  }
`;

export default WithDirection(PreviewTemplateWrapper);